import React, { useEffect, useState } from 'react'
import ModalConfirmarReimprimirDespachos from './ModalConfirmarReimprimirDespachos'
import { fechaActual } from '../../../hooks/UseDate'
import { postReimprimirDespachoPrincipal } from '../../../services/FarmaciaRuta'
import Loading from '../../Loading'

const ModalUserReimprimirDespachosFarmacia = ({setmodalOnReimprimirDespacho,dataUserReimprimirDespacho,userdata}) => {
  const [modalOnPDFReimprimirDespachos,setmodalOnPDFReimprimirDespachos]=useState(false)
  const [dataReimprimir, setdataReimprimir]=useState([])
  const [dataUser, setdataUser]=useState([])
  const [loading,setloading]=useState(true)
  const handleCancelarClick=()=>{
        setmodalOnReimprimirDespacho(false)
    }
    const handleOnclickPDF=(item)=>{
      console.log(item,'item data')
      setdataUser(item)
      setmodalOnPDFReimprimirDespachos(true)
    }
    const handleOnsubmitBuscar=(e)=>{
      e.preventDefault();
      setloading(false)
      const buscar={
        "HISCKEY" : userdata.HISCKEY,
        "HISTipDoc" : userdata.HISTipDoc,
        "HISCLPR": e.target.tipoAtencion.value, //tipo de atencion.
        "HISCSEC": e.target.folio.value, //folio
        "DSmFHrMov": e.target.fechaInicio.value, 
        //"fechaFin": e.target.fechaFinal.value
    }
      console.log(buscar,'buscar')
        postReimprimirDespachoPrincipal(buscar).then((res)=>{
          setdataReimprimir(Object.values(res.data))
          setloading(true)
        }).catch((error)=>{
          setdataReimprimir([])
          setloading(true)
        })
    }

    useEffect(()=>{
      setdataReimprimir(dataUserReimprimirDespacho)
    },[])
  return (
    <div
          className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
          id="exampleModalScrollable"
          tabIndex="-1"
          aria-labelledby="exampleModalScrollableLabel"
          aria-hidden="true"
        >
          <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
            <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
              <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
                <h5
                  className="text-xl font-medium leading-normal text-white "
                  id="exampleModalScrollableLabel"
                >
                  Reimpresión de Despacho
                </h5>
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  X
                </button>
              </div>
              <h5 className='text-center'>
                  {dataUserReimprimirDespacho? dataUserReimprimirDespacho[0].MPNOMC:null}
              </h5>
              <div className="flex-auto overflow-y-auto relative p-2">
                <form onSubmit={handleOnsubmitBuscar}>
                  <div className="flex py-2 text-left">
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Nro Folio
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.ProCirCod}
                          //disabled={true}
                          type="number"
                          name="folio"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Tipo de Atención
                      </label>
                      <div className="flex">
                      <select name="tipoAtencion" className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "  >
                     <option value=''>Todos</option>
                     <option value='1'>Cons. Externa</option>
                     <option value='2'>Hospitalización</option>
                     <option value='3'>Urgencias</option>
                     <option value='4'>Trat. especial</option>
                     <option value='5'>Triage</option>
                     <option value='6'>Ref. Cons. Externa</option>
                     <option value='7'>Ref. Hospitalización</option>
                     <option value='8'>Ref. Urgencias</option>
                     <option value='9'>Ref. Trat. Especial</option>
                    
                </select>
                        {/* <label className="px-2"></label>
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={props.userDate.ProEmpCod}
                          name="nombre"
                          type="text"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className="flex py-2 text-left">
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Fecha
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.MPTDoc}
                          //name="especialidadMedico"
                          //disabled={true}
                          name='fechaInicio'
                          defaultValue={fechaActual()}
                          type="date"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        <button
                          type="submit"
                          className="inline-block px-4 py-0.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                        >
                          Buscar
                        </button>
                      </div>
                    </div>
                    {/* <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Fecha Final 
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.MPCedu}
                          //name="especialidadMedico"
                          //disabled={true}
                          name='fechaFinal'
                          defaultValue={fechaActual()}
                          type="date"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        <button
                          type="submit"
                          className="inline-block px-4 py-0.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                        >
                          Buscar
                        </button>
                      </div>
                    </div> */}
                    {/* <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Nombre
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.MPNOMC}
                          //name="especialidadMedico"
                          //disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        <button
                          type="submit"
                          className="inline-block px-4 py-0.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                        >
                          Buscar
                        </button>
                      </div>
                    </div> */}
                  </div>
                  <div className="flex py-2 text-left">
                    
                    {/* <div className="w-1/3  px-1 flex">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Despacho con dispositivo implantable 
                      </label>
                      <div className="px-2">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.MPCedu}
                          //name="especialidadMedico"
                          //disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#fef9c3] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        
                      </div>
                    </div> */}
                    {/* <div className="w-1/3  px-1 flex">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Despacho sin dispositivo implantable
                      </label>
                      <div className="px-3">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.MPNOMC}
                          //name="especialidadMedico"
                          //disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#bbf7d0] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                  
                      </div>
                    </div> */}
                  </div>
                </form>
                <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                          <thead className="">
                            <tr>
                              <th></th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Folio
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Ingreso
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Formulario por:
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Servicio
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Transacción
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Docto
                              </th>
                              
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                               No.Movimiento
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Fec. / Hor. Mov.
                              </th>
                              
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Tipo Despacho
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Nro. Despacho
                              </th>
                              
                              
                              
                              
                            </tr>
                          </thead>
                          {
                            loading?
                            dataReimprimir.map((item,index)=>(
                              <tr key={index} className= 'divide-y divide-slate-700  rounded-none'>
                                <td></td>
                                <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                  <button
                                    //type="submit"
                                    onClick={()=>handleOnclickPDF(item)}
                                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                                  >
                                    Seleccionar
                                  </button>
                                </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.HISCSEC? item.HISCSEC:null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.DsCtvIn1? item.DsCtvIn1:null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
                                      
                                      {item.MMNomM? item.MMNomM.trim():null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.HISCLPR === '1'? 'Ambulatorio':(item.HISCLPR === '2'? 'Hospitalización': (item.HISCLPR === '3'?'Urgencias': (item.HISCLPR === '4'?'Tratamiento especial':(item.HISCLPR === '5'? 'Triage':null))))}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.DSmTpoTrn === 'DS'? 'DESPACHADO':(item.DSmTpoTrn === 'DV'? 'DEVUELTO': (item.DSmTpoTrn === 'CA'?'DEVUELTO':null))}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.DSCodDoc? item.DSCodDoc:null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.DsNumDoc? item.DsNumDoc:null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.DSmFHrMov? item.DSmFHrMov:null}
                                    </td>
                                    
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.DsmTipDsp === 'P'? 'Propios':null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.DsCnsDsp? item.DsCnsDsp:null}
                                    </td>
                              </tr>
                            ))
                            :
                            
                            <tr  className= 'divide-y divide-slate-700  rounded-none'>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td><Loading/></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>

                          }
                          
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cerrar
                </button>
                {/* <button
                //type="submit"
                //onClick={handleClickGuardarCantidadesSuministros}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Guardar
              </button> */}
              </div>
            </div>
          </div>
          {modalOnPDFReimprimirDespachos? <ModalConfirmarReimprimirDespachos setmodalOnPDFReimprimirDespachos={setmodalOnPDFReimprimirDespachos} dataUser={dataUser}/>:null}
        </div>
  )
}

export default ModalUserReimprimirDespachosFarmacia